import { Component, OnInit, Input, HostListener } from '@angular/core';
import { computed, observable } from 'mobx-angular';
import { ChartData, ChartOptions } from 'chart.js';
import { LabelOptions } from 'chartjs-plugin-datalabels/types/options';
import { KeyMetric } from '../EngineiusHomepage/engineius-homepage.component';
import { KeyMetricValue } from '../../../services';
export type ChartWithDataLabelsOptions = ChartOptions | { plugins: { datalabels: LabelOptions } };

@Component({
  selector: 'key-metric',
  templateUrl: './key-metric.component.html',
  styleUrls: ['./key-metric.component.scss'],
})
export class KeyMetricComponent implements OnInit {
  @Input() @observable metric: KeyMetric;

  @Input() @observable loading: boolean = false;

  @Input() @observable showGraph: boolean = false;

  @Input() @observable showTargetDifference: boolean = false;

  isViewportAtLeastMedium: boolean = window.innerWidth >= 768;

  @HostListener('window:resize', []) onWindowResize() {
    this.isViewportAtLeastMedium = window.innerWidth >= 768;
  }

  @computed get valueText(): string {
    return `${this.metric.preUnit || ''}${this.metric.currentPeriod.actualValue.toLocaleString()}${
      this.metric.postUnit || ''
    }`;
  }

  @computed get targetDifference(): number {
    return this.metric.currentPeriod.actualValue - this.metric.currentPeriod.targetValue;
  }

  @computed get belowTarget(): boolean {
    return this.targetDifference < 0;
  }

  @computed get targetText(): string {
    return `${this.belowTarget ? '-' : '+'}${this.metric.preUnit || ''}${
      this.loading ? '--' : Math.abs(this.targetDifference).toLocaleString()
    }${this.metric.postUnit || ''}`;
  }

  @computed get chartData(): ChartData {
    return {
      labels: [
        this.metric.previousPeriod.periodLabel,
        this.metric.currentPeriod.periodLabel,
        this.metric.nextPeriod.periodLabel,
      ],
      datasets: [
        {
          label: 'Actual',
          data: [this.metric.previousPeriod.actualValue, this.metric.currentPeriod.actualValue],
          backgroundColor: [
            this.getBarColour(this.metric.previousPeriod),
            this.getBarColour(this.metric.currentPeriod),
            this.getBarColour(this.metric.nextPeriod),
          ],
        },
        {
          label: 'Target',
          data: [
            this.metric.previousPeriod.targetValue,
            this.metric.currentPeriod.targetValue,
            this.metric.nextPeriod.targetValue,
          ],
          backgroundColor: '#0082c3',
          borderColor: '#0082c3',
        },
      ],
    };
  }

  @computed get chartOptions(): ChartWithDataLabelsOptions {
    return {
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          font: {
            family: 'Roboto,"Helvetica Neue",sans-serif',
            weight: 'bold',
          },
          color: 'white',
          // align: 'center',
          // anchor: 'start',
          // borderRadius: 4,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: { min: 0 },
            display: false,
            // barPercentage: 1.0,
            // barThickness: 30,
            // gridLines:{
            //   display: false
            // },
          },
        ],
        xAxes: [
          {
            barPercentage: 1.0,
            ticks: {
              padding: 10,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      // showLines: false,
      // tooltips: {
      //   enabled: false
      // },
      // hover: {
      //   mode: null
      // }
    };
  }

  constructor() {}

  ngOnInit() {}

  private getBarColour(kmv: KeyMetricValue): string {
    return kmv.actualValue < kmv.targetValue ? 'rgba(236,101,101,1.0)' : 'rgba(102,197,102,1.0)';
  }
}
